module.exports = __webpack_public_path__ + "static/media/icon-recieve-request-arrow.0dbda7fa.svg";